import React from 'react';
import { Box, Button, Card, Form, Image, Heading, Text, TextInput, ResponsiveContext } from 'grommet';
import {
    Elements,
    PaymentElement,
    useElements,
    useStripe,
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getSimpleDateFR, isPhone, toCurrency } from '../../../services/utils';
import logo from '../../../images/logo.png'
import translate from '../../../i18n/translate';
import { ABONNEMENT, PRODUCT } from '../../../services/types';

const { stripe_key } = require('../../../../configs/config.json');

const stripePromise = loadStripe(stripe_key);


const Payment = ({ devis, onLoading, success_url, onFailed, priceToPay, next_echeance, clientSecret, fullPrice, product, onPaid }) => {

    return (
        <ResponsiveContext.Consumer>
            {size => (
                <Elements
                    stripe={stripePromise}
                    options={{ clientSecret, appearance: { theme: 'stripe' } }}
                >
                    <Box
                        style={{ marginTop: 65, width: '100%', marginBottom: 165 }}
                        justify="center"
                        pad={'small'}
                        direction={isPhone(size) ? 'column' : "row"}
                    >

                        <Card pad="xlarge" gap="small" background='#525f7f' align="center">
                            <Box width="small">
                                <Image src={logo} fit="cover" />
                            </Box>
                            <Text>{translate('payer')}</Text>
                            <Box justify='center' align='center'>

                                <Text style={{ fontWeight: 'bold' }} size="xxlarge" textAlign='center'>
                                    {toCurrency(priceToPay)} <br />
                                    <Text style={{ fontWeight: 'bold' }} size="large" textAlign='center'>
                                        {product === PRODUCT.MH_TEMPO ?
                                            ``
                                            :
                                            ` ${devis.abonnement === ABONNEMENT.monthly ? translate('mensuellement') : translate('annuellement')}`
                                        }
                                    </Text>
                                </Text>
                            </Box>

                            {devis.promo?.value &&
                                <Text size="xsmall" textAlign="center">
                                    ({translate('reduction_de')} <strong>-{toCurrency(devis.promo.value)} </strong> {translate('applique')})
                                </Text>
                            }

                            {product === PRODUCT.MH_TEMPO ? null :
                                <Text size="xsmall" textAlign="center">
                                    {translate('puis')} {toCurrency(fullPrice)} {` / ${devis.abonnement === ABONNEMENT.monthly ? translate('month') : translate('year')}`}<br />
                                    {translate('a_partir')} {getSimpleDateFR(new Date(next_echeance))}
                                </Text>
                            }

                        </Card>
                        <Card pad="medium" gap="medium">
                            <Text style={{ fontWeight: 'bold' }}>
                                {translate('donnee_paiement')}
                            </Text>
                            <PaymentComponent
                                clientSecret={clientSecret}
                                onLoading={onLoading}
                                success_url={success_url}
                                onFailed={onFailed}
                                priceToPay={priceToPay}
                                onPaid={onPaid}
                            />
                        </Card>
                    </Box>
                </Elements>
            )}
        </ResponsiveContext.Consumer>
    )
}

const PaymentComponent = ({ onLoading, success_url, priceToPay, onFailed, onPaid }) => {
    const [messages, _setMessages] = React.useState('');
    // helper for displaying status messages.
    const setMessage = (message) => {
        _setMessages(`${messages}\n\n${message}`);
    }

    // Initialize an instance of stripe.
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (e) => {
        e.preventDefault();
        onLoading();
        onPaid();

        // Use card Element to tokenize payment details
        const { error } = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: success_url,
            },
        });



        if (error) {
            // show error and collect new card details.
            setMessage(error.message);
            onFailed();
            return;
        }
    }
    return (
        <Form onSubmit={handleSubmit}>
            <Box gap="medium" justify="center">
                <PaymentElement id="payment-element" />
                {messages &&
                    <Box >
                        <Text color='#fd9644' size="xsmall">{messages}</Text>
                    </Box>
                }
                <Button type="submit" primary label={`${translate('massure_pour')} ${toCurrency(priceToPay)}`} />
            </Box>
        </Form>
    )
}

export default Payment;
